<template>
  <v-data-table
    :headers="tableHeaders"
    :items="FTData"
    :loading="isLoading"
    class="elevation-1"
  >
    <template v-slot:item.actions="{ item }" v-if="!isAdmin">
      <v-icon small class="hidden-sm-and-down" @click="onDeleteItem(item._id)">
        mdi-delete
      </v-icon>

      <v-btn
        outlined
        class="ml-4 hidden-sm-and-up red--text"
        @click="onDeleteItem(item._id)"
      >
        delete
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      headers: [
        { text: "Created", value: "date" },
        { text: "Scheduled Date", value: "scheduledDate" },
        { text: "Fluid Intake", value: "fluid" },
        { text: "Scheduled", value: "scheduled" },
        { text: "Created By", value: "createdBy" },
      ],
      FTData: [],
      isLoading: false,
      basicUser: [
        "Direct Care Staff",
        "Shift Lead",
        "House Manager",
        "Assistant Manager",
      ],
      userRole: localStorage.getItem("userRole"),
    };
  },

  created() {
    this.fetch();
  },

  computed: {
    isAdmin() {
      return !this.basicUser.includes(this.userRole);
    },
    tableHeaders() {
      return this.isAdmin
        ? [...this.headers, { text: "Action", value: "actions" }]
        : this.headers;
    },
  },

  methods: {
    ...mapActions("fluidTrackingCharts", ["getItemById", "deleteItem"]),

    async fetch() {
      try {
        this.isLoading = true;
        const response = await this.getItemById(this.$route.query.ftId);
        this.FTData = response.data.map((item) => ({
          ...item,
          date: moment(item.date).format("YYYY-MM-DD hh:mm A"),
          fluid: item.hasRecord
            ? item.fluidIntakes
                .map((item) => `${item.cup}${item.fluid}${item.location}`)
                .join(", ")
            : "No FT",
        }));
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async onDeleteItem(id) {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmation.isConfirmed) {
        try {
          const response = await this.deleteItem(id);
          if (response.success) {
            Swal.fire({
              title: "Deleted!",
              text: response.msg,
              icon: "success",
            });
            this.fetch();
            this.$emit("fetch-chart-data");
          }
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      }
    },
  },
};
</script>
